<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-阳光房订单-修改
    -->
    <el-dialog
    title=""
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="70%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form"  label-width="100px">
    

      <el-form-item label="内容" >
        <div class="edit_container">
          <Uediter :text="obj[code]" :config="ueditor.config" ref="ue" @contentChange="contentChangeFunc"></Uediter>
        </div>
      </el-form-item>



      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
   
    </div>
 
</el-dialog>
  
</template>

<script>
import HproductApi from '@/api/hproduct.js';
import Uediter from '@/components/UE.vue';

export default {
  components: {
    Uediter,
  },
  data() {
    return {

      /*富文本配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        intro:"",
        image_text:""
      },
      loading: false,

      dialogVisible:false,

    };
  },
  created() {

    this.dialogVisible = this.open_add;
  },
  props: ["open_add","hproduct_id",'obj','code'],
  methods: {
 

    onSubmit() {
      let self = this;
      let form = self.obj;

      form.hproduct_id = self.hproduct_id;
      form.code = self.code;
 
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          HproductApi.editPart(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
 
              self.dialogFormVisible("error")
            })
            .catch(error => {
  
              self.loading = false;
            });
        }
      });
    },

     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
 
       /*获取富文本内容*/
       contentChangeFunc(e) {
      this.obj[this.code] = e;
    },
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}



.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/supply/product/part/tz.vue